'use strict';

var toConsumableArray = require('../node_modules/@babel/runtime/helpers/toConsumableArray.js');
var _typeof = require('../node_modules/@babel/runtime/helpers/typeof.js');
var React = require('react');
require('prop-types');
var makeStyles = require('../DesignSystem/Styles/makeStyles.js');
var classNames = require('classnames');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var useStyles = makeStyles["default"]({
  textStyle: function textStyle(_ref) {
    var wordBreak = _ref.wordBreak;
    return {
      wordBreak: wordBreak,
      overflowWrap: 'break-word'
    };
  }
});

var TruncateText = function TruncateText(_ref2) {
  var className = _ref2.className,
      _ref2$truncate = _ref2.truncate,
      truncate = _ref2$truncate === void 0 ? true : _ref2$truncate,
      _ref2$maxLines = _ref2.maxLines,
      maxLines = _ref2$maxLines === void 0 ? 2 : _ref2$maxLines,
      children = _ref2.children,
      _ref2$dependencies = _ref2.dependencies,
      dependencies = _ref2$dependencies === void 0 ? [] : _ref2$dependencies,
      _ref2$charStep = _ref2.charStep,
      charStep = _ref2$charStep === void 0 ? 10 : _ref2$charStep,
      _ref2$onTruncate = _ref2.onTruncate,
      onTruncate = _ref2$onTruncate === void 0 ? function (truncate) {} : _ref2$onTruncate,
      _ref2$wordBreak = _ref2.wordBreak,
      wordBreak = _ref2$wordBreak === void 0 ? 'break-all' : _ref2$wordBreak;

  var _useStyles = useStyles({
    wordBreak: wordBreak
  }),
      textStyle = _useStyles.textStyle;

  var onRefSet = React.useCallback(function (spanRef) {
    if (!spanRef || children === undefined || children === null || !children.toString) return;
    var stringifiedChildren = children.toString();

    if (_typeof["default"](children) === 'object') {
      stringifiedChildren = JSON.stringify(children);
    }

    if (!truncate) {
      spanRef.textContent = stringifiedChildren;
      return;
    }

    if (maxLines <= 0 || !stringifiedChildren) {
      spanRef.textContent = '';
      return;
    }

    displayMaxLines(spanRef, stringifiedChildren);
  }, [children, truncate, maxLines].concat(toConsumableArray(dependencies)));

  var displayMaxLines = function displayMaxLines(spanRef, stringifiedChildren) {
    spanRef.textContent = '';
    var totalDisplayedChars = 0;
    var linesOfText = 0;
    var currOffsetHeight = 0;

    while (totalDisplayedChars <= stringifiedChildren.length) {
      totalDisplayedChars += charStep;
      spanRef.textContent = stringifiedChildren.slice(0, totalDisplayedChars);

      if (spanRef.offsetHeight > currOffsetHeight) {
        linesOfText += 1;
        currOffsetHeight = spanRef.offsetHeight;
      }

      if (linesOfText > maxLines) {
        createEllipsis(spanRef, totalDisplayedChars, stringifiedChildren);
        return;
      }
    }

    spanRef.textContent = stringifiedChildren.slice(0, stringifiedChildren.length);
    onTruncate(false);
  };

  var createEllipsis = function createEllipsis(spanRef, totalDisplayedChars, stringifiedChildren) {
    var displayedChars = totalDisplayedChars;
    spanRef.textContent = "".concat(stringifiedChildren.slice(0, displayedChars), "...");
    var overflowOffsetHeight = spanRef.offsetHeight;

    while (spanRef.offsetHeight === overflowOffsetHeight && displayedChars > 0) {
      displayedChars -= 1;

      if (displayedChars === 0) {
        spanRef.textContent = '';
        break;
      }

      spanRef.textContent = "".concat(stringifiedChildren.slice(0, displayedChars), "...");
    }

    onTruncate(true);
  };

  return React__default["default"].createElement("span", {
    className: classNames__default["default"](textStyle, className),
    ref: onRefSet
  });
};

module.exports = TruncateText;
